import React, {useState} from 'react'
import {Row, Col /*, Tab, Tabs*/} from 'react-bootstrap'
import {CaretRight} from 'react-bootstrap-icons'
import ReactTooltip from 'react-tooltip'
import materialtextures from './config/material.json'
import TextureSelectionPad from './TextureSelectorPad' 
import HelpTip from './HelpTip'
import './css/ConfiguratorPads.css'

const sects = ['glass','matte','metal'];
const carpetsects = ['moquette','rubber'];
const basedir = `${process.env.PUBLIC_URL}`;

export default function SelectionPanel (props) 
{

    const [current, setCurrent] = useState(props.selectedItem)
    //const [section, setSection] = useState('glass');
    //const [carpetsection, setCarpetSection] = useState('moquette');
    let openBackTop = props.selectedItem==='backTop';
    let openBackBottom = props.selectedItem==='backBottom';
    let openCarpet = props.selectedItem==='carpet';
    let openMonitor = props.selectedItem==='screen';

 
    const callSelect = config=>{
        if( current || props.selectedItem)
            props.select( current || props.selectedItem, config );
    }

    const setMonitorOnOff = e=>{

        props.select( 'monitor', e.target.checked );
    }

    const handleClick = el=> {
        let item
        el.target.dataset.item===props.selectedItem?
            item=null:
            item = el.target.dataset.item;
        props.onClick(item)
        setCurrent( item )
    }

    let thmbs = {};
    ['backTop','backBottom','carpet'].forEach(el => {
        const m = props.config[el].material;
        const t = props.config[el].texture;
        const isColor = materialtextures[m][t].charAt(0)==='#';
           
        const panelstyle = isColor? {backgroundColor: materialtextures[m][t]}:
                                    {backgroundImage: `url(${basedir}/textures/${materialtextures[m][t]}`};
        thmbs[el] =     <>
                            <div 
                                data-item={el}
                                style={panelstyle}
                                data-texture={ {'texture': t, 'type': props.config[el].type, 'material': m }}
                                className='thumbnail'
                                onClick={handleClick}
                                data-tip
                                data-for={`texttip-${el}`}
                            />
                            <ReactTooltip id={`texttip-${el}`} place="right" effect="solid">
                                {`${t} [${m}]`}
                            </ReactTooltip>
                        </>

    });  



    return (
        <div className='overlay'>
            <div className='p-2 texture-selector-container'>
                <Row className='col-12 border-bottom border-muted'>
                    <Col className='col-11'>
                        <h4 className='text-enhanced'>
                            CABIN
                            <HelpTip />
                        </h4>
                    </Col>
                </Row>
                <Row className={`col-12 text-white border-bottom border-secondary${openMonitor?' tex-selected':null}`}>
                    <Col className='col-5 p-2'>
                        <h5 className="conf-title" data-item="screen" onClick={handleClick}>MONITOR</h5>
                    </Col>
                    <Col className='col-7 p-2'>
                        <input type="checkbox" onChange={e=>setMonitorOnOff(e)} checked={props.config.monitor}/>
                    </Col>
                </Row>

                <Row className={`col-12 text-white border-bottom border-secondary${openBackTop?' tex-selected':null}`}>
                    <Col className='col-5 p-2'>
                        <h5 className="conf-title" data-item="backTop" onClick={handleClick}>BACKTOP PANEL</h5>
                    </Col>
                    <Col className='col-4 p-2'>
                        <h5 className='leggera-open-btn'>
                            <CaretRight className={openBackTop?' deg90':null} data-item="backTop" onClick={handleClick}/>
                        </h5>
                    </Col>
                    <Col className='col-3 p-2'>
                        {thmbs.backTop}
                    </Col>
                    {openBackTop?                        
                        <TextureSelectionPad 
                            sections={sects}
                            defaultsection='glass'
                            select={callSelect}
                        />:null}
                </Row>
                <Row className={`col-12 text-white border-bottom border-secondary${openBackBottom?' tex-selected':null}`}>
                    <Col className='col-5 p-2'>
                        <h5 className="conf-title" data-item="backBottom" onClick={handleClick}>BACKBOTTOM PANEL</h5>
                    </Col>
                    <Col className='col-4 p-2'>
                        <h5 className='leggera-open-btn'>
                            <CaretRight className={openBackBottom?' deg90':null} data-item="backBottom" onClick={handleClick}/>
                        </h5>
                    </Col>
                    <Col className='col-3 p-2'>
                        {thmbs.backBottom}
                    </Col>
                    {openBackBottom?                        
                        <TextureSelectionPad 
                            sections={sects}
                            defaultsection='glass'
                            select={callSelect}
                        />:null}
                </Row>
                <Row className={`col-12 text-white border-bottom border-secondary${openCarpet?' tex-selected':null}`}>
                    <Col className='col-5 p-2'>
                        <h5 className="conf-title" data-item="carpet" onClick={handleClick}>CARPET</h5>
                    </Col>
                    <Col className='col-4 p-2'>
                        <h5 className='leggera-open-btn'>
                            <CaretRight className={openCarpet?' deg90':null} data-item="carpet" onClick={handleClick}/>
                        </h5>
                    </Col>
                    <Col className='col-3 p-2'>
                        {thmbs.carpet}
                    </Col>
                    {openCarpet?                        
                        <TextureSelectionPad 
                            sections={carpetsects}
                            defaultsection='moquette'
                            select={callSelect}
                        />:null}

                </Row>
            </div>

        </div>
    );
}

